import React from 'react'
import { InlineMath } from 'react-katex'
import 'katex/dist/katex.min.css'

// fungsi parsing string ke JSX
const parseLatexString = (input) => {
   // regex untuk deteksi pola sederhana seperti 3^2, 5^3, a^2, dsb.
   // serta operator "x" atau "*" untuk perkalian
   const regex = /(\d+\^\d+|\w+\^\d+|\d+\s*[x*]\s*\d+)/g

   const parts = input.split(regex)

   return parts.map((part, idx) => {
      if (regex.test(part)) {
         // ubah format supaya sesuai dengan LaTeX
         let formatted = part
            .replace(/(\d+)\^(\d+)/g, '$1^{$2}') // pangkat → superscript
            .replace(/x|\*/g, '\\times') // simbol kali

         return <InlineMath key={idx} math={formatted} />
      }
      return <span key={idx}>{part}</span>
   })
}

export default parseLatexString
